import {App} from "vue";

declare module '@vue/runtime-core' {
	export interface ComponentCustomProperties {
		$wp: {
			type?: string,
			data?: any,
			header?: any,
			footer?: any,
		}
	}
}

export const WPPlugin = {
	install(app: App) {
		Object.defineProperty(app.config.globalProperties, "$wp", {
			get() {
				return {
					type: (window as any)._wp_type,
					data: (window as any)._wp_data,
					header: (window as any)._wp_header,
					footer: (window as any)._wp_footer,
				}
			}
		})
	}
}
